<template>
  <v-toolbar :style="{paddingLeft : mini ? '75px' : '250px'}" style="background: white">
    <v-toolbar-side-icon v-if="currentPageWidth > 1200" @click="toggleSidebar()"></v-toolbar-side-icon>
    <v-spacer></v-spacer>
    <v-menu offset-y class="user-menu">
      <v-btn
        slot="activator"
        color="white"
        round
      >
        Witaj,&nbsp;<strong>{{getUserName}}</strong>
        <v-icon class="ml-2" size="16px">fas fa-chevron-down</v-icon>
      </v-btn>
      <v-list class="user-menu-dropdown">
        <v-list-tile @click="openPasswordChange = true">
          <v-list-tile-title>
            <v-icon class="mr-1" size="16px" style="margin-bottom: 2px">fas fa-user-alt</v-icon>
            Zmiana hasła
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="logout()">
          <v-list-tile-title>
            <v-icon class="mr-1" size="16px" style="margin-bottom: 2px">fas fa-sign-out-alt</v-icon>
            Wyloguj
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <PasswordChange :open="openPasswordChange"
                    @close="openPasswordChange = false"></PasswordChange>
  </v-toolbar>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import PasswordChange from '../../views/ChangePassword.vue';

  export default {
    name: 'AppHeader',
    props: {
      currentPageWidth: Number,
    },
    components: {
      PasswordChange,
    },
    data() {
      return {
        mini: false,
        currentLang: 'PL',
        openPasswordChange: false,
      };
    },
    computed: {
      ...mapGetters('AuthStore', ['getUserName']),
    },
    methods: {
      ...mapActions('AuthStore', ['logout']),
      changeLang(lang) {
        this.currentLang = lang;
      },
      toggleSidebar() {
        this.mini = !this.mini;
        this.$emit('toggleSidebar', this.mini);
      },
    },
  };
</script>

<style scoped>
</style>
